var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[(!_vm.loading)?_c('Form',{attrs:{"header":_vm.header,"options":[
      _vm.assessment_level,
      _vm.physical_examination
    ],"isReadOnly":_vm.isReadOnly},on:{"submit":_vm.submitForm}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }